const PIXEL_ID = "a2_imn92dfp0oup";

// Track whether the pixel has been initialized
let isInitialized = false;

/**
 * The Reddit pixel's own loader (the snippet that used to sit in
 * public/index.html and fetch pixel.js on every page view, before any
 * consent). Now it runs only from here, after the visitor accepts: a queue
 * stub collects calls until pixel.js arrives.
 */
function ensurePixelLoaded() {
  const w = window as any;
  if (w.rdt) return;
  const p: any = (w.rdt = function (...args: unknown[]) {
    if (p.sendEvent) p.sendEvent.apply(p, args);
    else p.callQueue.push(args);
  });
  p.callQueue = [];
  const t = document.createElement("script");
  t.src = `https://www.redditstatic.com/ads/pixel.js?pixel_id=${PIXEL_ID}`;
  t.async = true;
  const s = document.getElementsByTagName("script")[0];
  if (s?.parentNode) s.parentNode.insertBefore(t, s);
  else document.head.appendChild(t);
}

/**
 * Initialize and track the first PageVisit (call after user consent).
 */
export function initRedditPixel() {
  ensurePixelLoaded();
  if ((window as any).rdt) {
    try {
      (window as any).rdt('init', PIXEL_ID);
      (window as any).rdt('track', 'PageVisit');
      isInitialized = true;
    } catch (e) {
      console.warn('Reddit Pixel init failed:', e);
    }
  }
}

export function trackPageView() {
  // Only track if pixel has been initialized (user gave consent)
  if ((window as any).rdt && isInitialized) {
    try {
      (window as any).rdt('track', 'PageVisit');
    } catch (e) {
      console.warn('Reddit Pixel track failed:', e);
    }
  }
}

export function isPixelInitialized() {
  return isInitialized;
}

/**
 * Initialize the pixel with advanced matching options (hashed identifiers).
 * Call this only after obtaining explicit user consent and hashing PII.
 */
export function initWithOptions(pixelId: string, initOptions: Record<string, any>) {
  ensurePixelLoaded();
  if ((window as any).rdt) {
    try {
      (window as any).rdt('init', pixelId, initOptions);
    } catch (e) {
      console.warn('Reddit Pixel init with options failed:', e);
    }
  }
}

/**
 * Helper to compute SHA-256 hex of a value (trimmed, lowercased).
 * Use this to hash emails/phones before sending. Returns lowercase hex string.
 */
export async function sha256Hex(value: string) {
  const normalized = value.trim().toLowerCase();
  const data = new TextEncoder().encode(normalized);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
